/* eslint-disable */
export default {
  _ulna: 'ulna',
  _assemble_the_skeleton: 'assemble-the-skeleton',
  _femur: 'femur',
  _assemble: 'assemble',
  _carpals: 'carpals',
  _radius: 'radius',
  _pelvis: 'pelvis',
  _title: 'title',
  _label: 'label',
  _metatarsals: 'metatarsals',
  _metacarpals: 'metacarpals',
  _scapula: 'scapula',
  _tibia: 'tibia',
  _clavicle: 'clavicle',
  _humerus: 'humerus',
  _label_the_skeleton: 'label-the-skeleton',
  _tarsals: 'tarsals',
  _patella: 'patella',
  _hand: 'hand',
  _foot: 'foot',
  _fibula: 'fibula',
  _sternum: 'sternum',
  _hand_bones: 'hand_bones',
  _skull: 'skull',
  _spine: 'spine',
  _ribs: 'ribs',
  _face: 'face',
  _foot_bones: 'foot_bones',
}